import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormGroup } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { RolService } from './../../services/rol.service';
import { AmbRolUsuarioService } from './../../services/amb.rol.usuario.service';
import { IpPublicService } from './../../../../services/ip-public.service';
import { AmbienteService } from '../../../catalogos-admin/services/ambiente.service';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject, forkJoin, map } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Administración Sistema' },
    { label: 'Administración' },
    { label: 'Usuarios', active: true },
  ];

  public formUser!: UntypedFormGroup;

  public formRolAmbienteUser!: FormGroup;
  public formSubmittedAmbienteRol = false;
  public dataUpdate: any[] = [];
  public formSelectAplicaciones!: FormGroup;
  //public submitted = false;
  public formSubmitted = false;
  //private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataApp: any[] = [];
  public dataUserSiipne!: any;
  private idDeleteRegister: number = 0;
  private idSprUsuarioUpdate: number = 0;
  public selectItems: any[] = [];
  public nameModal: string = 'modalNewEdit';
  nameApp = 'Usuarios';

  public newPassword: string = '';
  public dataRoles!: any;
  public dataAmbientes!: any;
  public dataAmbientesRoles!: any;
  public dataAmbientesRolesUsuarios!: any;
  public userCurrentGestion!: any;
  public idSprUsuarioAplicacionSeleccionado!: any;
  actualizaClave: Boolean = false;
  public nombres!: any;
  public apellidos!: any;
  public grado!: any;
  currentUser: UsuarioRedux = null;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private fb: FormBuilder,
    private rolService: RolService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private ambienteService: AmbienteService,
    private ambRolUsuarioService: AmbRolUsuarioService,
    private userService: UserService,

    private store: Store<AppState>
  ) {
    /*this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);*/
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  setSelectRoles() { }

  get rolForm() {
    return this.formUser.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }
  setForm() {
    this.formUser = this.fb.group({
      idSprUsuario: [0],
      cedula: ['', [Validators.required]],
    });
    this.formRolAmbienteUser = this.fb.group({
      idSprAmbRolUsuario: [''],
      idSprUsuario: ['', [Validators.required]],
      idSprRol: [' ', [Validators.required]],
      idSprAmbiente: [' ', [Validators.required]],
      estado: [' '],
    });

    this.formSelectAplicaciones = this.fb.group({
      spr_idSprAplicacion: ['0', []],
    });

    /*    this.formUser.patchValue({
      estado: this.selectItems[0].value,
    }); */
  }



  ngOnInit(): void {
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUser = response.currentUser;
    });
    this.getIpPublic();
    this.initApp();
  }

  initApp() {
    this.listUsers();
    this.getDataMain();
    this.setDataTable();
    this.setForm();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  //##########################################
  // Trae usuarios del sistema
  //#########################################
  listUsers() {
    this.userService.getDataUsers().subscribe((resp) => {
      this.dataApp = resp;
      this.reDrawDataTable();
    });
  }

  // listDataApp() {
  //   this.rolService.list().subscribe((resp) => {
  //     this.dataApp = resp;
  //     this.reDrawDataTable();
  //   });
  // }

  //##########################################
  // Trae catalogo de ambientes
  //#########################################
  getDataMain() {
    let condicionRol = '?estado=1&admin=2';
    if (ConstantsCatalogosIdService.ADMINISTRADOR == 1 || ConstantsCatalogosIdService.SUBADMINISTRADOR == 2) {
      condicionRol = '?estado=1';
    }
    forkJoin([
      this.ambienteService.list(condicionRol),
      this.ambRolUsuarioService.list(),
      this.rolService.list(),

      //this.userService.getDataUsers()
    ])
      .pipe(map(([ambientes, rolUsuario, roles]) => {
        this.dataAmbientes = ambientes;
        this.dataAmbientesRolesUsuarios = rolUsuario;
        this.dataRoles = roles;
        this.mapeoUsuarioAmbienteRol();
      }
      )
      )
      .subscribe();
  }


  mapeoUsuarioAmbienteRol() {
    let dataProcess: any = [];
    if (this.dataAmbientesRoles) {
      for (let i = 0; i < this.dataAmbientesRoles.length; i++) {
        for (let j = 0; j < this.dataAmbientes.length; j++) {
          if (
            this.dataAmbientesRoles[i].idSprAmbiente ==
            this.dataAmbientes[j].idSprAmbiente
          ) {
            for (let k = 0; k < this.dataRoles.length; k++) {
              if (
                this.dataAmbientesRoles[i].idSprRol ==
                this.dataRoles[k].idSprRol
              ) {
                dataProcess.push({
                  idSprAmbRolUsuario:
                    this.dataAmbientesRoles[i].idSprAmbRolUsuario,
                  idSprAmbiente: this.dataAmbientesRoles[i].idSprAmbiente,
                  nombreUnidad: this.dataAmbientes[j].nombreUnidad,
                  nivel: this.dataAmbientes[j].nivel.nombre,
                  idSprRol: this.dataRoles[k].idSprRol,
                  nombreRol: this.dataRoles[k].nombre,
                  estado: this.dataAmbientesRoles[i].estado,
                });
              }
            }
          }
        }
      }
      this.dataAmbientesRolesUsuarios = dataProcess;
    }
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  delete(idRegister: number) {
    this.modal.open('delete');
    this.idDeleteRegister = idRegister;
  }
  /////////////////VERIFICA RLACIONADOS///////////////////////
  verifyAmbRolUsuario() {
    return this.ambRolUsuarioService
      .list(`?idSprUsuario=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }
  /////////////////////////////////////////////////////////////////////////
  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyAmbRolUsuario();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################
    if (confirmDelete) {
      this.userService
        .delete({
          idSprUsuario: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    } else {
      this.alert.warning(
        '¡Atención!',
        'No se puede borrar, existe Ambiente-Rol relacionado.'
      );
    }
  }

  deleteUserRol(idRegister: number) {
    this.modal.open('delete-user-rol');
    this.idDeleteRegister = idRegister;
  }

  confirmDeleteUSerRolAmbiente() {
    if (this.idDeleteRegister > 0) {
      this.ambRolUsuarioService
        .delete({
          idSprAmbRolUsuario: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.modal.closeId('delete-user-rol');
            this.changeDataUser(this.userCurrentGestion);
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    }
  }

  openModal() {
    this.onResetForm();
    this.setForm();
    this.modal.open(this.nameModal);
  }

  closeModal() {
    this.modal.close();


  }

  onResetForm() {
    this.limpiarCamposUsuarioNuevo();
    this.formSubmitted = false;
    this.formUser.reset();
  }

  createUser() { }
  /*   deleteUsuarioRolAmbiente(idsprAmbUsuarioRol: number){
        this.ambRolUsuarioService
          .delete({
            idsprAmbRolUsuario: idsprAmbUsuarioRol,
            usuario: this.currentUser.idSprUsuario,
            delLog: 'S',
            ip: this.ipAddress,
          })
          .subscribe(
            (resp) => {
              this.initApp();
              this.changeDataUser(this.userCurrentGestion);
              this.alert.deleteOk()
            },
            (err) => {
              this.alert.deleteError()
            }
          );
  } */

  buscaPersona() {
    this.limpiarCamposUsuarioNuevo();
    if (this.validarCedula(this.formUser.value.cedula) || this.formUser.value.cedula == undefined) {
      this.formSubmitted = true;
      try {
        if (!this.formUser.invalid) {
          this.userService.getPersonaSiipne(this.formUser.value.cedula).subscribe({
            next: (response) => {
             
              let grado = response.result.grado != null ? response.result.grado : "EC";
              this.dataUserSiipne = {
                 ...response.result, 
                 grado: grado 
                };

              if (this.dataUserSiipne.idGenPersona == undefined || this.dataUserSiipne.idGenPersona == null) {
                this.alert.warning("¡Atención!", this.dataUserSiipne + " / o esta desabilitado");
                return;
              }
              if (!response) {
                this.alert.warning('¡Atención!',
                  'No existe usuario con esta cédula.'

                );
              } else {
                this.setearValores(this.dataUserSiipne);
                // Petición de usuari
                this.newPassword = 'N/A';//this.dataUserSiipne.claveUsuario;
                this.userService.list(`?cedula=${this.dataUserSiipne.cedula}`).subscribe({
                  next: (userSprResp) => {
                    let userSpr = userSprResp;
                    if (userSpr.length > 0) {
                      this.idSprUsuarioUpdate = userSpr[0].idSprUsuario;
                      this.actualizaClave = true;
                      //this.alert.warning("¡Atención!", "Usted puede actualizar la clave de este usuario, presionando guardar!");
                    } else {
                      this.actualizaClave = false;
                    }
                  }
                });
              }

            },
            error: (error) => {
              console.log('[INFO] Data-error:', error);
            }
          });
        }
      }
      catch (error) {
        console.log('[INFO] Data-Error :', error);
      }
    }
  }


  changeDataUser(rowUser: any) {
    this.getDataMain();
    this.userCurrentGestion = rowUser;
    this.idSprUsuarioAplicacionSeleccionado =
      rowUser.idSprUsuario > 0 ? rowUser.idSprUsuario : 0;
    this.idSprUsuarioAplicacionSeleccionado >= 1
      ? this.getDataRolAmbienteUser(rowUser.idSprUsuario)
      : '';
    this.openModal();
    rowUser.idSprRol >= 0 ? rowUser.idSprRol : 0;
    rowUser.idSprAmbiente >= 0 ? rowUser.idSprAmbiente : 0;

    this.formRolAmbienteUser.patchValue({
      idSprUsuario: rowUser.idSprUsuario,
      idSprRol: rowUser.idSprRol,
      idSprAmbiente: rowUser.idSprAmbiente,
    });
    this.formUser.patchValue({
      cedula: rowUser.cedula,
      idSprUsusario: rowUser.idSprUsusario,
    });
    this.apellidos = rowUser.apellidos;
    this.grado = rowUser.grado;
    this.nombres = rowUser.nombres;
  }

  getDataRolAmbienteUser(idSprUsuario: number) {
    this.ambRolUsuarioService
      .list(`?idSprUsuario=${idSprUsuario}`)
      .subscribe((resp) => {
        this.dataAmbientesRoles = resp;
        this.getDataMain();
      });
  }

  setearValores(data: any) {
    this.nombres = data.nombres;
    this.apellidos = data.apellidos;
    this.grado = data.grado;// ? data.grado : "EC";
  }
  validarCedula(cedula: string): boolean {
    if (cedula == null) {
      this.alert.warning('¡Atención!', 'Debe ingresar el número de cédula.');
      return false;
    }

    if (cedula.length < 10) {
      this.alert.warning(
        '¡Atención!',
        'El número de cédula debe tener 10 digitos.'
      );
      return false;
    }
    return true;
  }

  limpiarCamposUsuarioNuevo() {
    this.nombres = '';
    this.apellidos = '';
    this.grado = '';
    // Limpia los campos relacionados con los ambientes
    this.dataAmbientesRolesUsuarios = [];
  }

  createAmbienteRolUser() {
    if (this.formRolAmbienteUser.value.idSprAmbRolUsuario == '') {
      this.formRolAmbienteUser.value.usuario = this.currentUser.idSprUsuario;
      this.formRolAmbienteUser.value.ip = this.ipAddress;
      this.formRolAmbienteUser.value.idSprAmbRolUsuario = null;
      this.formRolAmbienteUser.value.estado = 1;
      this.formRolAmbienteUser.value.delLog = 'N';
      this.formSubmittedAmbienteRol = true;
      if (this.formRolAmbienteUser.value.idSprUsuario == null || this.formRolAmbienteUser.value.idSprUsuario == "") {
        this.alert.warning('Atención', 'Primero debe crear/guardar al usuario al que asignará un ambiente-rol');
        return;
      }
      if (!this.formRolAmbienteUser.invalid) {
        //Realizar el posteo
        if (this.formRolAmbienteUser.value.idSprUsuario >= 1) {
          try {
            this.ambRolUsuarioService
              .create(this.formRolAmbienteUser.value)
              .subscribe({
                next: (data) => {
                  this.alert.createOk();
                  this.initApp();
                  this.limpiarCamposUsuarioNuevo();
                  this.changeDataUser(this.userCurrentGestion);
                },
                error: (error) => {
                  //this.alert.alert('Atención!','No se puede crear,  el ' + error.error.detail,'warning'
                  //);
                },
              });
          } catch (e) { }
        }
        //this.initApp();
      } else {
      }
    } else {
      const formData = this.formRolAmbienteUser.value;
      this.ambRolUsuarioService.update(formData).subscribe(
        (response) => {
          this.formRolAmbienteUser.reset();
          this.changeDataUser(this.userCurrentGestion);
        },
        (error) => {
          console.error('Error al actualizar el registro', error);
        }
      );
    }



  }

  editarPermisoAmbiente(rowUser: any) {
    this.formRolAmbienteUser.patchValue({
      idSprAmbRolUsuario: rowUser.idSprAmbRolUsuario,
      idSprRol: rowUser.idSprRol,
      idSprAmbiente: rowUser.idSprAmbiente,
      estado: rowUser.estado,
    });

  }

  createUserSpr() {
    if (this.actualizaClave) {
      this.alert.warning('¡Atención!', 'Este usuario ya esta registrado en el SPR.');
     
      //   this.dataUpdate.push({
      //   ip: this.ipAddress,
      //   usuario: this.currentUser.idSprUsuario,
      //   claveUsuario: 'N/A',
      //   idSprUsuario: this.idSprUsuarioUpdate
      // });

      // console.log('[INFO] ', this.dataUpdate);
      // this.userService.update(this.dataUpdate).subscribe({
      //   next: (data: any) => {
      //     this.alert.success('¡Correcto!', 'Clave actualizada correctamente con el SIIPNE 3W del usuario seleccionado!');
      //     this.closeModal();
      //     this.limpiarCamposUsuarioNuevo();
      //     this.initApp();
      //   },
      //   error: (response: any) => {
      //     );
      //   },
      // });
      return;
    }

    if (this.dataUserSiipne && !this.actualizaClave) {
      this.dataUserSiipne.estado = 1;
      this.dataUserSiipne.ip = this.ipAddress;
      this.dataUserSiipne.usuario = this.currentUser.idSprUsuario;
      this.dataUserSiipne.claveUsuario = 'N/A';

      try {
        console.log('[INFO] ', this.dataUserSiipne);
        this.userService.create(this.dataUserSiipne).subscribe({
          next: (data: any) => {
            this.alert.success('¡Correcto!', 'Usuario creado satisfactoriamente.');
            this.closeModal();
            this.limpiarCamposUsuarioNuevo();
            this.initApp();
          },
          error: (response: any) => {
            // this.alert.warning('¡Atención!','No se puede crear el usuario, el ' + response.error.detail
            // );
          },
        });
      } catch (e) { }
    } else {
      this.alert.warning('¡Atención!', 'Primero debe buscar un usuario.');
    }
  }
}
